<script>
import Form from '@classes/Form'
import BodySitePicker from '@components/body-site-picker.vue'
import { surgeryService } from '@/src/services/SurgeryService'
import { procedureService } from '@services/ProcedureService'
import { healthRecordService } from '@services/HealthRecordService'
import { medicalDateFormatter, isBeforeDate } from '@utils/medical-date'
import ComboBox from '@components/combo-box.vue'
import { authComputed, authMethods, optionsComputed } from '@state/helpers'
import MedicalDatePickerDialog from '@components/dialogs/medical-date-picker-dialog.vue'
import hrMixin from '@src/mixins/hr-mixin.vue'
import store from '@state/store'
export default {
  page: {
    title: 'Surgery Editor',
    meta: [{ name: 'description', content: 'The Surgery Editor page.' }],
  },
  components: {
    ComboBox,
    MedicalDatePickerDialog,
    BodySitePicker,
  },
  mixins: [hrMixin],
  props: {
    formDialog: {
      type: Boolean,
      default: false,
    },
    formChanged: {
      type: Boolean,
      default: false,
    },
    formSaved: {
      type: Boolean,
      default: false,
    },
    formSavedAnother: {
      type: Boolean,
      default: false,
    },
    attachmentDeleted: {
      type: Boolean,
      default: false,
    },
    create: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    resource: {
      type: String,
      default: 'surgery',
    },

    show: {
      type: Boolean,
      default: false,
    },
    unauth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      row: 'surgery',
      surgeryForm: new Form({
        date: null,
        date_part: '',
        surgery: '',
        implant: '',
        complication: '',
        histology_report: '',
        hospital: '',
        body_sites: [],
        note: '',
        private: false,
      }),
      procedureForm: new Form({
        date: null,
        date_part: '',
        procedure: '',
        implant: '',
        complication: '',
        histology_report: '',
        hospital: '',
        body_sites: [],
        note: '',
        private: false,
      }),
      complicationSurgery: '',
      complicationProcedure: '',
      histologyReportSurgery: '',
      histologyReportProcedure: '',
      surgeryImplant: '',
      procedureImplant: '',
      surgeryAttachments: [],
      originalSurgeryAttachments: [],
      procedureAttachments: [],
      originalProcedureAttachments: [],
      medicalDatePickerDialog: false,
      procedureError: null,
      attachments: [],
      showHRActions: true,
    }
  },
  computed: {
    ...authComputed,
    ...optionsComputed,
    histologyReportsSurgery() {
      return this.getSurgeryOptions?.histology_report
        ? this.getSurgeryOptions.histology_report
        : []
    },
    complicationsSurgery() {
      return this.getSurgeryOptions?.complication
        ? this.getSurgeryOptions.complication
        : []
    },
    complicationsSurgeryDropdown: {
      get() {
        return this.complicationSurgery
      },
      set(value) {
        if (value !== 'other') {
          this.surgeryForm.complication = value
        } else {
          this.surgeryForm.complication = ''
        }
        this.complicationSurgery = value
      },
    },
    complicationsProcedureDropdown: {
      get() {
        return this.complicationProcedure
      },
      set(value) {
        if (value !== 'other') {
          this.procedureForm.complication = value
        } else {
          this.procedureForm.complication = ''
        }
        this.complicationProcedure = value
      },
    },
    histologyReportsSurgeryDropdown: {
      get() {
        return this.histologyReportSurgery
      },
      set(value) {
        if (value !== 'significant-findings-present') {
          this.surgeryForm.histology_report = value
        } else {
          this.surgeryForm.histology_report = ''
        }
        if (value) {
          this.histologyReportSurgery = value
        }
      },
    },
    histologyReportsProcedureDropdown: {
      get() {
        return this.histologyReportProcedure
      },
      set(value) {
        if (value !== 'significant-findings-present') {
          this.procedureForm.histology_report = value
        } else {
          this.procedureForm.histology_report = ''
        }
        this.histologyReportProcedure = value
      },
    },
    histologyReportsProcedure() {
      return this.getProcedureOptions?.histology_report
        ? this.getProcedureOptions.histology_report
        : []
    },
    complicationsProcedure() {
      return this.getProcedureOptions?.complication
        ? this.getProcedureOptions.complication
        : []
    },
    canSaveSurgery() {
      if (
        (this.surgeryForm.date || this.surgeryForm.date_part === 'past') &&
        this.row === 'surgery' &&
        this.surgeryForm.surgery &&
        this.surgeryForm.complication
      ) {
        return true
      }
      return false
    },
    canSaveProcedure() {
      if (
        (this.procedureForm.date || this.procedureForm.date_part === 'past') &&
        this.row === 'procedure' &&
        this.procedureForm.procedure &&
        this.procedureError === null &&
        this.dateError === null
      ) {
        return true
      }
      return false
    },
    computedRecord: {
      get() {
        if (this.row === 'surgery') {
          return this.surgeryForm.private
        } else {
          return this.procedureForm.private
        }
      },
      set(value) {
        if (this.row === 'surgery') {
          this.surgeryForm.private = value
        } else {
          this.procedureForm.private = value
        }
      },
    },
  },
  watch: {
    surgeryForm: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$emit('update:formChanged', true)
        }
      },
      deep: true,
    },
    procedureForm: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$emit('update:formChanged', true)
        }
      },
      deep: true,
    },
    surgeryImplant(newValue, oldValue) {
      if (newValue === 'no') {
        this.surgeryForm.implant = ''
      }
    },
    procedureImplant(newValue, oldValue) {
      if (newValue === 'no') {
        this.procedureForm.implant = ''
      }
    },
    row(newValue, oldValue) {
      if (newValue === 'surgery') {
        this.procedureForm.reset()
        this.procedureAttachments = []
        this.procedureImplant = ''
      } else {
        this.surgeryForm.reset()
        this.surgeryAttachments = []
        this.surgeryImplant = ''
      }
      this.procedureError = null
      this.dateError = null
    },
  },
  async mounted() {
    try {
      if (!this.getSurgeryOptions) {
        const surgeryOptions = (await surgeryService.options()).data
        if (surgeryOptions) {
          store.dispatch('options/setSurgeryOptions', surgeryOptions)
        }
      }

      if (!this.getProcedureOptions) {
        const procedureOptions = (await procedureService.options()).data
        if (procedureOptions) {
          store.dispatch('options/setProcedureOptions', procedureOptions)
        }
      }

      if (this.edit) {
        if (this.item.patient_id !== null) {
          this.showHRActions = false
        }
        this.row = this.item.record_type
        this.itemToForm(this.item)
      }
    } catch (error) {
      console.warn(error)
    }
  },
  methods: {
    ...authMethods,
    clearForm() {
      this.surgeryForm.reset()
      this.procedureForm.reset()
      this.surgeryForm.complication = ''
      this.procedureAttachments = []
      this.surgeryAttachments = []
      this.surgeryImplant = ''
      this.procedureImplant = ''
      this.message = false
      this.isAnother = false
      this.isContinue = false
      this.procedureError = null
      this.dateError = null
    },
    setProcedureBodySites(selectedBodySites) {
      this.procedureForm.body_sites = selectedBodySites
    },
    setSurgeryBodySites(selectedBodySites) {
      this.surgeryForm.body_sites = selectedBodySites
    },
    setMedicalDate(medicalDate, past) {
      const field = this.medicalDatePickerName
      const fieldPart = this.medicalDatePickerName + '_part'

      const medicalDateObject = medicalDateFormatter(medicalDate)

      if (this.row === 'surgery') {
        this.surgeryForm[field] = medicalDateObject.date
        this.surgeryForm[fieldPart] = this.determinePast(
          past,
          medicalDateObject
        )
      } else {
        this.procedureForm[field] = medicalDateObject.date
        this.procedureForm[fieldPart] = this.determinePast(
          past,
          medicalDateObject
        )
      }

      this.medicalDatePickerDialog = false
    },
    async getSurgeryResponse() {
      if (this.edit) {
        return (
          await healthRecordService.update(
            this.item.hr_id,
            this.surgeryForm.removeEmptyStringFromData()
          )
        ).data
      } else {
        return (
          await surgeryService.create(this.surgeryForm.removeEmptyFromData())
        ).data
      }
    },
    async getProcedureResponse() {
      if (this.edit) {
        return (
          await healthRecordService.update(
            this.item.hr_id,
            this.procedureForm.removeEmptyStringFromData()
          )
        ).data
      } else {
        return (
          await procedureService.create(
            this.procedureForm.removeEmptyFromData()
          )
        ).data
      }
    },
    async deleteAttachmentSurgery(id) {
      try {
        const response = await surgeryService.attachmentDelete(id)
        if (response) {
          this.originalSurgeryAttachments = this.originalSurgeryAttachments.filter(
            function(obj) {
              return obj.id !== id
            }
          )
          this.$emit('update:attachmentDeleted', true)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    async deleteAttachmentProcedure(id) {
      try {
        const response = await procedureService.attachmentDelete(id)
        if (response) {
          this.originalProcedureAttachments = this.originalProcedureAttachments.filter(
            function(obj) {
              return obj.id !== id
            }
          )
          this.$emit('update:attachmentDeleted', true)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    setErrors(error) {
      if (this.row === 'surgery') {
        this.surgeryForm.onFail(error.response.data)
      } else {
        this.procedureForm.onFail(error.response.data)
      }
      if (this.hasResponse) {
        this.message = true
        this.$emit('update:formSaved', true)
      }
      this.procedureError = error
    },
    async tryToSave(action) {
      this.resetFlagsAndErrors('procedureError', action)
      try {
        let surgeryResponse = null
        let procedureResponse = null
        if (this.row === 'surgery') {
          if (
            this.surgeryForm.date &&
            isBeforeDate(
              this.surgeryForm.date,
              new Date().toISOString().split('T')[0]
            )
          ) {
            this.dateError = this.$t('start-after-today')
            this.scrollToErrors()
            return
          }

          surgeryResponse = await this.getSurgeryResponse()

          if (surgeryResponse) {
            this.hasResponse = true
            let responseAttachments

            if (this.surgeryAttachments.length > 0) {
              responseAttachments = (
                await surgeryService.attachments(
                  this.surgeryAttachments,
                  surgeryResponse.hr_id,
                  'surgery'
                )
              ).data

              console.warn(responseAttachments)
            }
          }
        } else {
          if (
            this.procedureForm.date &&
            isBeforeDate(
              this.procedureForm.date,
              new Date().toISOString().split('T')[0]
            )
          ) {
            this.dateError = this.$t('start-after-today')
            this.scrollToErrors()
            return
          }

          procedureResponse = await this.getProcedureResponse()

          if (procedureResponse) {
            this.hasResponse = true
            let responseAttachmentsProcedure

            if (this.procedureAttachments.length > 0) {
              responseAttachmentsProcedure = (
                await procedureService.attachments(
                  this.procedureAttachments,
                  procedureResponse.hr_id,
                  'procedure'
                )
              ).data
              console.warn(responseAttachmentsProcedure)
            }
          }
        }
        if (surgeryResponse || procedureResponse) {
          await this.fetchWizardData()

          this.message = true
          if (
            action === 'continue' &&
            store.state.calender.addNewRecord === 'true'
          ) {
            this.$emit('update:formSaved', true)
            this.$emit('close-dialog')
            if (document.getElementById('getAllData'))
              document.getElementById('getAllData').click()
          }
          if (action === 'continue') {
            this.$emit('update:formSaved', true)
            this.edit ? this.$emit('close-dialog') : this.$emit('back')
            if (document.getElementById('getAllData'))
              document.getElementById('getAllData').click()
          }
          if (action === 'another') {
            this.$emit('update:formSavedAnother', true)
            this.clearForm()
            this.$emit('add-another')
            if (document.getElementById('updateGetAllData'))
              document.getElementById('updateGetAllData').click()
          }
        }
      } catch (error) {
        console.warn(error)
        this.setErrors(error)
        this.isAnother = false
        this.isContinue = false
        this.scrollToErrors()
      } finally {
        this.tryingToSave = false
      }
    },
    itemToForm(item) {
      if (this.row === 'surgery') {
        this.itemToSurgeryForm(item)
      } else {
        this.itemToProcedureForm(item)
      }
    },
    itemToSurgeryForm(item) {
      if (item.record.implant) {
        this.surgeryImplant = 'yes'
      }
      if (item.record.date) {
        this.surgeryForm.date = item.record.date
      }

      if (item.record.complication) {
        const hasComplicationFromArray = this.checkObjectArrayForValue(
          'complicationsSurgery',
          item.record.complication
        )
        if (!hasComplicationFromArray) {
          this.complicationSurgery = 'other'
        } else {
          this.complicationSurgery = item.record.complication
        }
      }

      this.surgeryForm.complication = item.record.complication

      if (item.record.histology_report) {
        const hasHistologyReportFromArray = this.checkObjectArrayForValue(
          'histologyReportsSurgery',
          item.record.histology_report
        )
        if (!hasHistologyReportFromArray) {
          this.histologyReportSurgery = 'significant-findings-present'
        } else {
          this.histologyReportSurgery = item.record.histology_report
        }
      }

      this.surgeryForm.histology_report = item.record.histology_report
      this.surgeryForm.date_part = item.record.date_part
      this.surgeryForm.surgery = item.record.surgery

      this.surgeryForm.implant = item.record.implant
      this.surgeryForm.hospital = item.record.hospital
      this.surgeryForm.note = item.note
      this.surgeryForm.private = item.private

      if (item.record.body_sites.length > 0) {
        for (let i = 0; i < item.record.body_sites.length; i++) {
          this.surgeryForm.body_sites.push(item.record.body_sites[i].code)
        }
      }
      this.originalSurgeryAttachments = item.attachments.map((element) => {
        return { ...element }
      })
    },
    itemToProcedureForm(item) {
      if (item.record.implant) {
        this.procedureImplant = 'yes'
      }
      if (item.record.date) {
        this.procedureForm.date = item.record.date
      }

      if (item.record.complication) {
        const hasComplicationFromArray = this.checkObjectArrayForValue(
          'complicationsProcedure',
          item.record.complication
        )

        if (!hasComplicationFromArray) {
          this.complicationProcedure = 'other'
        } else {
          this.complicationProcedure = item.record.complication
        }
      }

      this.procedureForm.complication = item.record.complication

      if (item.record.histology_report) {
        const hasHistologyReportFromArray = this.checkObjectArrayForValue(
          'histologyReportsProcedure',
          item.record.histology_report
        )
        if (!hasHistologyReportFromArray) {
          this.histologyReportProcedure = 'significant-findings-present'
        } else {
          this.histologyReportProcedure = item.record.histology_report
        }
      }

      this.procedureForm.histology_report = item.record.histology_report
      this.procedureForm.date_part = item.record.date_part
      this.procedureForm.procedure = item.record.procedure
      this.procedureForm.implant = item.record.implant
      this.procedureForm.hospital = item.record.hospital
      this.procedureForm.note = item.note
      this.procedureForm.private = item.private

      if (item.record.body_sites.length > 0) {
        for (let i = 0; i < item.record.body_sites.length; i++) {
          this.procedureForm.body_sites.push(item.record.body_sites[i].code)
        }
      }
      this.originalProcedureAttachments = item.attachments.map((element) => {
        return { ...element }
      })
    },
    checkObjectArrayForValue(arrayToCheck, value) {
      for (let i = 0; i < this[arrayToCheck].length; i++) {
        if (this[arrayToCheck][i].key === value) {
          return true
        }
      }
      return false
    },
  },
}
</script>

<template>
  <v-container @dragover.prevent @drop="onDrop">
    <v-row
      no-gutters
      :class="$style.hrHeader"
      class="primary--text mt-1"
      justify="center"
    >
      <div class="mr-4">
        <v-img
          :src="
            require('@assets/images/safehaven/health-record-icons/surgeries.svg')
          "
          height="30"
          width="30"
          contain
        ></v-img>
      </div>
      {{ $t('health-record.surgeries.surgery') }}
    </v-row>
    <v-fade-transition mode="out-in">
      <div v-if="row === 'surgery'">
        <v-row
          class="mt-10 offblack--text"
          :class="$style.hrQuestionFull"
          no-gutters
          justify="center"
        >
          What type of surgery is this?
        </v-row>
        <v-row class="mt-10" no-gutters justify="center">
          <div :class="$style.hrComboBoxContainer">
            <ComboBox
              :key="'surgery-combo-1'"
              :disabled="show"
              :combo-class="'surgery-combo-1'"
              :value.sync="surgeryForm.surgery"
              placeholder="e.g. Cardiac Surgery"
              :error-messages="
                surgeryForm.errors.has('surgery')
                  ? 'Surgery: ' + surgeryForm.errors.get('surgery')
                  : ''
              "
              :fetch-url="unauth ? null : '/api/v1/hr/choices/surgery/'"
              rounded
              filled
              background-color="input"
              :class="$style.hrComboBox"
              @keydown="
                clearFormFromErrors(
                  'surgery',
                  'surgeryForm',
                  // eslint-disable-next-line vue/comma-dangle
                  'procedureError'
                )
              "
            ></ComboBox>
          </div>
        </v-row>

        <v-row class="mt-7">
          <v-col cols="12" md="12">
            <v-row
              :class="$style.hrQuestion"
              class="my-auto offblack--text"
              no-gutters
              justify="center"
            >
              Is there any implant or material involved in the surgery?
            </v-row>
          </v-col>
          <v-row class="mt-2" justify="center">
            <v-radio-group
              v-model="surgeryImplant"
              :disabled="show"
              row
              class="my-auto"
              :class="$style.hrRadio"
            >
              <v-row class="my-auto" justify-md="start" justify="center">
                <v-radio label="No" value="no"></v-radio>
                <v-radio label="Yes" value="yes"></v-radio>
              </v-row>
            </v-radio-group>
          </v-row>
        </v-row>
        <div v-if="surgeryImplant === 'yes'">
          <v-row
            class="mt-10 offblack--text"
            :class="$style.hrQuestionFull"
            no-gutters
            justify="center"
            >What's the name of the implant or material?
          </v-row>
          <v-row class="mt-10" no-gutters justify="center">
            <v-text-field
              v-model="surgeryForm.implant"
              :disabled="show"
              placeholder="e.g. cardiac pacemaker"
              rounded
              filled
              background-color="input"
              :class="$style.hrTextField"
            />
          </v-row>
        </div>
        <v-row
          :class="$style.hrQuestionFull"
          class="mt-7 offblack--text"
          no-gutters
          justify="center"
        >
          What's the date of the surgery?
        </v-row>
        <v-row v-if="dateError" class="ml-1">
          <v-col cols="12" md="12">
            <p class="error--text">{{ dateError }}</p>
          </v-col>
        </v-row>
        <v-row class="mt-10" no-gutters justify="center">
          <div
            :class="
              mobile ? $style.medicalDateDivMobile : $style.medicalDateDiv
            "
          >
            <MedicalDatePickerDialog
              :key="'surgeryDate-1'"
              :disabled="show"
              :dialog.sync="medicalDatePickerDialog"
              :title="'health-record.surgeries.surgery-date'"
              :field="surgeryForm.date"
              :part="surgeryForm.date_part"
              filled
              background-color="input"
              :error-messages="
                surgeryForm.errors.has('date')
                  ? 'Surgery Date: ' + surgeryForm.errors.get('date')
                  : ''
              "
              @input="clearErrors('date', 'surgeryForm', 'procedureError')"
              @setMedicalDate="setMedicalDate"
              @showMedicalDate="showMedicalDate('date')"
            />
          </div>
        </v-row>

        <v-row
          class="mt-7 offblack--text"
          :class="$style.hrQuestionFull"
          no-gutters
          justify="center"
          >Any complications?
        </v-row>
        <v-row class="mt-10" no-gutters justify="center">
          <v-select
            v-model="complicationsSurgeryDropdown"
            :disabled="show"
            class="surgeryComplication"
            attach=".surgeryComplication"
            :items="complicationsSurgery"
            item-text="value"
            item-value="key"
            placeholder="Select Complication"
            clearable
            filled
            background-color="input"
            rounded
            :class="$style.hrSelect"
            :error-messages="
              surgeryForm.errors.has('complication')
                ? 'Complication: ' + surgeryForm.errors.get('complication')
                : ''
            "
            @change="
              clearFormFromErrors(
                'complication',
                'surgeryForm',
                // eslint-disable-next-line vue/comma-dangle
                'procedureError'
              )
            "
          />
        </v-row>

        <div v-if="complicationSurgery === 'other'">
          <v-row class="mt-10" no-gutters justify="center">
            <v-text-field
              v-model="surgeryForm.complication"
              :disabled="show"
              placeholder="Enter other complication"
              :class="$style.hrTextField"
              rounded
              filled
              background-color="input"
              :error-messages="
                surgeryForm.errors.has('complication')
                  ? 'Complication: ' + surgeryForm.errors.get('complication')
                  : ''
              "
              @input="
                clearFormFromErrors(
                  'complication',
                  'surgeryForm',
                  // eslint-disable-next-line vue/comma-dangle
                  'procedureError'
                )
              "
            />
          </v-row>
        </div>

        <v-row
          :class="$style.hrQuestionFull"
          class="mt-7 offblack--text"
          no-gutters
          justify="center"
          >What healthcare facility was this performed at?
        </v-row>
        <v-row class="mt-10" no-gutters justify="center">
          <v-text-field
            v-model="surgeryForm.hospital"
            :disabled="show"
            placeholder="e.g. Massachussets General Hospital"
            :class="$style.hrTextField"
            rounded
            filled
            background-color="input"
          />
        </v-row>
        <v-row
          :class="$style.hrQuestionFull"
          class="mt-7 offblack--text"
          no-gutters
          justify="center"
          >Are there any associated biopsy results?
        </v-row>
        <v-row class="mt-10" no-gutters justify="center">
          <v-select
            v-model="histologyReportsSurgeryDropdown"
            :disabled="show"
            class="surgeryHistologyReport"
            attach=".surgeryHistologyReport"
            :items="histologyReportsSurgery"
            item-text="value"
            item-value="key"
            placeholder="Select Results"
            clearable
            filled
            background-color="input"
            rounded
            :class="$style.hrSelect"
          />
        </v-row>

        <div v-if="histologyReportSurgery === 'significant-findings-present'">
          <v-row class="mt-10" no-gutters justify="center">
            <v-text-field
              v-model="surgeryForm.histology_report"
              :disabled="show"
              placeholder="Enter significant findings"
              :class="$style.hrTextField"
              rounded
              filled
              background-color="input"
              :error-messages="
                surgeryForm.errors.has('histology_report')
                  ? 'Significant findings: ' +
                    surgeryForm.errors.get('significant findings')
                  : ''
              "
              @input="
                clearFormFromErrors(
                  'significant findings',
                  'surgeryForm',
                  // eslint-disable-next-line vue/comma-dangle
                  'procedureError'
                )
              "
            />
          </v-row>
        </div>

        <v-row>
          <v-container class="fill-height">
            <v-row class="justify-center">
              <BodySitePicker
                :key="'condition-body-site'"
                :disabled="show"
                :body-sites="surgeryForm.body_sites"
                @update="setSurgeryBodySites"
              />
            </v-row>
          </v-container>
        </v-row>
        <v-row
          :class="$style.hrQuestionFull"
          class="mt-7 offblack--text"
          no-gutters
          justify="center"
        >
          Any additional files or notes you'd like to include?
        </v-row>
        <v-row class="mt-10">
          <div class="mx-auto" :class="$style.hrInputDiv">
            <SpeechToText
              :key="'surgery-2'"
              :disabled="show"
              :value.sync="surgeryForm.note"
              auto-grow
              rounded
              :class="$style.hrSpeechToText"
              :placeholder="$t('health-record.surgeries.note')"
            ></SpeechToText>
          </div>
        </v-row>
        <v-row class="mt-10">
          <div class="mx-auto" :class="$style.hrInputDiv">
            <FileUpload
              :key="'surgery-3'"
              :disabled="show"
              icon
              :height="200"
              :multiple="true"
              :files.sync="surgeryAttachments"
              :non-draggable="true"
            ></FileUpload>
          </div>
        </v-row>

        <v-row v-if="edit" class="mt-10">
          <div class="mx-auto" :class="$style.hrInputDiv">
            <AttachmentList
              :key="'attachment-list-1'"
              :disabled="show"
              :attachments="originalSurgeryAttachments"
              @delete-attachment="deleteAttachmentSurgery"
            ></AttachmentList>
          </div>
        </v-row>
      </div>
    </v-fade-transition>

    <div v-if="row !== ''">
      <ForMyEyesOnly v-if="!show" :value.sync="computedRecord" />
      <div v-if="showHRActions">
        <HrActions
          :can-save="canSaveSurgery || canSaveProcedure"
          :is-another="isAnother"
          :is-continue="isContinue"
          :trying-to-save="tryingToSave"
          :trying-to-delete="tryingToDelete"
          :edit="edit"
          @go-back="goBack"
          @try-to-save="tryToSave"
          @try-to-delete="prepareDeletion"
        />
      </div>
    </div>

    <v-row v-if="procedureError" class="ml-1">
      <v-col cols="12" md="12">
        <p class="error--text">{{ $t('health-record.surgeries.error') }}</p>
        <div v-if="surgeryForm.errors.has('non_field_errors')">
          <div
            v-for="(error, index) in surgeryForm.errors.getNonField(
              // eslint-disable-next-line vue/comma-dangle
              'non_field_errors'
            )"
            :key="'error-non-field' + index"
          >
            <p class="error--text">{{ error }}</p>
          </div>
        </div>
        <div v-if="procedureForm.errors.has('non_field_errors')">
          <div
            v-for="(error, index) in procedureForm.errors.getNonField(
              // eslint-disable-next-line vue/comma-dangle
              'non_field_errors'
            )"
            :key="'error-non-field' + index"
          >
            <p class="error--text">{{ error }}</p>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="message" class="ml-1">
      <p class="success--text">{{ $t('health-record.surgeries.message') }}</p>
    </v-row>
    <BaseConfirmDialog
      v-if="confirmDialog"
      :dialog="confirmDialog"
      :message="computedMessage"
      title="Delete Item"
      @cancel="cancel"
      @confirm="deleteItem"
    />
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.hrHeader {
  width: 100%;
  font-family: $system-default-font-family;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrQuestion {
  font-family: $system-default-font-family;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrQuestionFull {
  width: 100%;
  font-family: $system-default-font-family;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrRadio {
  // styleName: Mobile / Display Small;
  font-family: $system-default-font-family;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: left;
  letter-spacing: 1px;
}
.hrComboBoxContainer {
  width: 394px;
}

.hrComboBox {
  border-radius: 15px !important;
}
.hrTextField {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrAutoComplete {
  width: 394px;
}
.hrSelect {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrInputDiv {
  width: 394px;
  border-radius: 15px !important;
}
.hrSpeechToText {
  max-width: 394px !important;
  background: $color-theme-light-input;
}
.hrButton {
  border-radius: 8px !important;
}
.medicalDateDiv {
  width: 394px;
  margin-right: auto;
  margin-left: auto;
}
.medicalDateDivMobile {
  width: 60%;
  margin-right: auto;
  margin-left: auto;
}
</style>
